<template>
  <div>
    <!-- 普通商品推荐 -->
    <div class="add">
      <!-- 添加分类 -->
      <el-button type="success" class="AddTheClassification" size="small" @click="add" v-if="isAuth(389)">
        {{ $t("message.AddTheClassification") }}</el-button>
    </div>
    <div class="table">
      <!--     default-expand-all 全部展開 -->
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#F0F0F0 ' }" row-key="id"
        :tree-props="{ children: 'childs', hasChildren: 'hasChildren' }">
        <!-- 中文名称 -->
        <el-table-column :label="$t('message.ChineseName')" prop="chinese_name" width="300px">
        </el-table-column>
        <!-- 译文名称 -->
        <el-table-column :label="$t('message.translationName')" align="center" prop="translate_name">
        </el-table-column>
        <!--  排序-->
        <el-table-column :label="$t('message.sort')" align="center" prop="sort" width="50px">
        </el-table-column>

        <!--PC版主图  -->
        <el-table-column :label="$t('message.web_img')" align="center" width="120px">
          <template slot-scope="scope">
            <img :src="scope.row.list_banner" alt="" />
          </template>
        </el-table-column>
        <!-- 默认背景颜色 -->

        <el-table-column :label="$t('message.default_back_color')" align="center" width="150px" prop="default_back_color">
        </el-table-column>
        <!--  触发时背景颜色-->
        <el-table-column :label="$t('message.trigger_back_color')" align="center" width="150px" prop="default_back_color">
        </el-table-column>

        <!-- 描述 -->
        <el-table-column :label="$t('message.note')" align="center" prop="remark">
        </el-table-column>
        <!--操作  -->
        <el-table-column :label="$t('message.operation')" align="center" width="120px">
          <template slot-scope="scope">
            <div class="a-flex">
              <i class="el-icon-edit" @click="edit(scope.row)" v-if="isAuth(389)"></i>
              <i class="el-icon-delete" @click="autoGoodsGroupDelete(scope.row.id)" v-if="isAuth(390)"></i>
            </div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 添加编辑分类 -->

    <el-dialog :title="dialogVisibleTitle" :close-on-click-modal="false" :visible.sync="dialogVisible" width="600px"
      center>
      <div class="form">
        <el-form :model="datas" :rules="rules" ref="form" label-width="130px" class="demo-ruleForm">
          <!-- 中文名称： -->
          <el-form-item :label="$t('message.ChineseName') + '：'" prop="chinese_name">
            <el-input v-model="datas.chinese_name" onfocus="this.select()"></el-input>
          </el-form-item>
          <!-- 译文名称： -->
          <el-form-item :label="$t('message.translationName') + '：'" prop="translate_name">
            <el-input v-model="datas.translate_name" onfocus="this.select()"></el-input>
          </el-form-item>

          <!--排序：  -->
          <el-form-item :label="$t('message.sort') + '：'" prop="sort">
            <div class="input">
              <el-input v-model="datas.sort" onfocus="this.select()"></el-input>
            </div>
            <!-- *数字越大越靠前 -->
            <span style="color: #b4272d">{{ $t("message.theHigherTheNumber") }}
            </span>
          </el-form-item>
          <!-- 上级分类： -->
          <el-form-item :label="$t('message.TheCigherClassification') + '：'">
            <el-cascader v-model="datas.parent_ids" :options="tableData" :props="{
              checkStrictly: true,
              label: 'chinese_name',
              children: 'childs',
              expandTrigger: 'hover',
              value: 'id',
            }" clearable filterable></el-cascader>
          </el-form-item>

          <!-- PC版主图 -->
          <el-form-item :label="$t('message.web_img') + '：'">
            <el-upload :action="uploadUrl" :show-file-list="false" :on-success="defaultSuccess"
              :before-upload="beforeAvatarUpload">
              <img v-if="datas.list_banner" :src="datas.list_banner" class="avatar" />
              <i v-else class="el-icon-plus avatar-uploader-icon"></i>
            </el-upload>
          </el-form-item>
          <!--默认背景颜色 -->
          <el-form-item :label="$t('message.default_back_color') + '：'">
            <el-input v-model="datas.default_back_color" onfocus="this.select()"></el-input>
          </el-form-item>
          <!--  触发时背景颜色 -->
          <el-form-item :label="$t('message.trigger_back_color') + '：'">
            <el-input v-model="datas.trigger_back_color" onfocus="this.select()"></el-input>
          </el-form-item>
          <!-- 描述： -->
          <el-form-item :label="$t('message.note') + '：'">
            <el-input v-model="datas.remark" onfocus="this.select()"></el-input>
          </el-form-item>
        </el-form>
      </div>

      <span slot="footer" class="dialog-footer">
        <!-- 取消 -->
        <el-button @click="dialogVisible = false">{{
          $t("message.cancel")
        }}</el-button>
        <!-- 确定 -->
        <el-button type="primary" @click="autoGoodsGroupSave">{{
          $t("message.save")
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
export default {
  data() {
    return {
      tableData: [],
      datas: {},
      rules: {
        chinese_name: [
          {
            required: true,
            message: this.$t("message.pleaseChineseName"),
            trigger: "blur",
          },
        ],
        translate_name: [
          {
            required: true,
            message: this.$t("message.pleaseTranslationName"),
            trigger: "blur",
          },
        ],
      },
      dialogVisibleTitle: "",
      dialogVisible: false,
      uploadUrl: "https://jpapi.rakumart.cn/api/common/uploadFile",
    };
  },
  created() {
    this.autoGoodsGroup();
  },
  methods: {
    autoGoodsGroup() {
      this.$api.siteConfiguration.autoGoodsGroup().then((res) => {
        this.tableData = res.data;
      });
    },
    // 新增
    add() {
      this.datas = {
        chinese_name: "",
        parent_ids: [],
        translate_name: "",
        parent_id: "",
        list_banner: "",
        default_back_color: "",
        trigger_back_color: "",
        sort: "0",
        remark: "",
      };
      this.dialogVisible = true;
      this.dialogVisibleTitle = "添加-分类";
    },
    // 修改
    edit(item) {
      this.datas = JSON.parse(JSON.stringify(item));
      this.datas.parent_ids = this.datas.parent_id - 0;
      this.dialogVisible = true;
      this.dialogVisibleTitle = "编辑-分类";
    },
    // 删除
    autoGoodsGroupDelete(id) {
      this.$confirm(
        this.$t("message.areYouSureToDelete"),
        this.$t("message.prompt"),
        {
          confirmButtonText: this.$t("message.save"),
          cancelButtonText: this.$t("message.cancel"),
          type: "warning",
          center: true,
        }
      )
        .then(() => {
          this.$api.siteConfiguration
            .autoGoodsGroupDelete({ id })
            .then((res) => {
              if (res.code != 0) return this.$message.error(res.msg);
              this.$message.success(res.msg);

              this.autoGoodsGroup();
            });
        })
        .catch(() => { });
    },
    // 默认 添加修改图片
    defaultSuccess(file) {
      if (file.code != 0) return this.$message.error(file.msg);
      this.datas.list_banner = file.data;
      this.loading = false;
      this.$forceUpdate();
    },

    // 图片格式
    beforeAvatarUpload(file) {
      const isJPG = file.type === "image/jpeg";
      const isPNG = file.type === "image/png";
      const isSVG = file.type === "image/svg+xml";
      this.loading = true;
      if (!isJPG && !isPNG && !isSVG) {
        this.$message.error("上传图片只能是 JPG,PNG 格式,SVG格式!");
        this.loading = false;
      }
      return isJPG || isPNG || isSVG;
    },

    autoGoodsGroupSave() {
      if (this.datas.parent_ids.length > 0) {
        this.datas.parent_id =
          this.datas.parent_ids[this.datas.parent_ids.length - 1];
      }
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.$api.siteConfiguration
            .autoGoodsGroupSave(this.datas)
            .then((res) => {
              this.autoGoodsGroup();
              this.dialogVisible = false;
            });
        }
      });
    },
  },
};
</script>
<style lang='scss' scoped>
.add {
  position: absolute;
  top: 25px;
  right: 24px;
  z-index: 999;
}

/deep/.el-table__expand-icon {
  i {
    font-size: 20px;
  }
}

img {
  width: 40px;
  height: 60px;
}

.a-flex {
  display: flex;

  i {
    flex: 1;
    font-size: 20px;
    cursor: pointer;
  }
}

/deep/.el-table__row {
  background-color: #edeff4;
}

.form {
  padding: 20px 10px 10px;
  border-radius: 6px;
  background-color: #edeff4;

  /deep/.el-upload {
    width: 40px;
    height: 40px;
    border: 1px dashed #ccc;
    border-radius: 4px;
  }

  .el-cascader {
    width: 100%;
  }

  .avatar {
    width: 40px;
    height: 40px;
  }
}
</style>